import DOMPurify from 'dompurify';
import {marked} from 'marked';
import React from 'react';

const SAFE_MARKDOWN_TAGS = [
  // NOTE: We purposefully don't include a, img, script, etc. to limit risk.
  // headers
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  // text
  'p',
  'span',
  // rule & break
  'hr',
  'br',
  // code
  'code',
  'pre',
  // lists
  'li',
  'ul',
  'ol',
  // italics
  'em',
  // bold
  'strong',
  'b',
  // quotes
  'blockquote',
  'q',
  // strikethrough
  's',
  'del',
];

export interface LLMMarkdownProps {
  markdown: string;
}

export default function LLMMarkdownSection({markdown}: LLMMarkdownProps): JSX.Element {
  return (
    <section
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(marked(markdown), {
          ALLOWED_ATTR: [], // it is critical for security to not allow any attributes
          ALLOWED_TAGS: SAFE_MARKDOWN_TAGS,
        }),
      }}
    />
  );
}
